import AtypicalDeals from './AtypicalDeals';

import type { Configs } from '@shared/types/configs';
import type { I18nService } from '@shared/types/i18n';
import type { Stay } from '@shared/types/utils';
import type { Destination } from '@shared/ui/types';

import {
  useMinPrice,
  usePollingStatus,
  usePriceContext,
} from '@hotels-hotel-detail/data-access/hooks/useHotelOffersContext';
import AtypicalDealsProvider from '@shared/data-access-frontend/AtypicalDealsProvider';
import { withI18n } from '@shared/ui/contexts/i18n';
import { withConfiguration } from '@shared/utils-frontend/contexts/ConfigurationContext';

type Props = {
  i18n: I18nService;
  configs: Configs;
  stay: Stay;
  destination: Destination;
  isMobile?: boolean;
};
const AtypicalDealsContainer = ({
  configs: { enableAtypicalDealsCall },
  destination,
  i18n,
  isMobile,
  stay,
}: Props) => {
  const { entity, entityId } = destination;
  const { taxAndFeeInclusionPolicy } = usePriceContext();
  const isPollingFinished = usePollingStatus();
  const minPrice = useMinPrice();

  return (
    <AtypicalDealsProvider
      stay={stay}
      entityId={entityId}
      entityType="Hotel"
      i18n={i18n}
      enabled={enableAtypicalDealsCall}
      taxAndFeeInclusionPolicy={taxAndFeeInclusionPolicy}
      isPollingFinished={isPollingFinished}
      baselinePrice={minPrice}
    >
      <AtypicalDeals hotelName={entity} isMobile={isMobile} />
    </AtypicalDealsProvider>
  );
};

export default withI18n(withConfiguration(AtypicalDealsContainer));
